import { render, staticRenderFns } from "./GridStack.vue?vue&type=template&id=197a792b&scoped=true&"
import script from "../../js/widgets/GridStack.js?vue&type=script&lang=js&"
export * from "../../js/widgets/GridStack.js?vue&type=script&lang=js&"
import style0 from "./GridStack.vue?vue&type=style&index=0&id=197a792b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a792b",
  null
  
)

export default component.exports